import apiWrapper from '../../services/apiWrapper';

const checkLoginStatus = async () => {
  try {
    const response = await apiWrapper('get', '/check-login-status');
    return {
      success: response.success,
      isLoggedIn: response.isLoggedIn
    };
  } catch (error) {
    console.error('Check login status error:', error.message);
    return {
      success: false,
      isLoggedIn: false
    };
  }
};

export default checkLoginStatus;